import { render, staticRenderFns } from "./DocGetterDialog.vue?vue&type=template&id=f3804c42&"
import script from "./DocGetterDialog.vue?vue&type=script&lang=ts&"
export * from "./DocGetterDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DocGetterDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VRow,VTextField})
